import React from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { iconOutlinedFlag } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { ReportAbuseLink } from 'src/app/shared/components/abuse';

import type { SupporterVideo } from '../../shared/types';

import { useReportVideo } from './hooks/useReportVideo';

type ReportVideoProps = {
	video: SupporterVideo;
	petitionId: string;
	petitionSlug: string;
};
export function ReportVideo({ video, petitionId, petitionSlug }: ReportVideoProps): React.JSX.Element | null {
	const {
		data: { canReportVideo },
		actions: { handleReportClick },
	} = useReportVideo({ petitionId, video });

	const { translate } = useI18n();

	if (!canReportVideo) return null;

	return (
		<Flex onClick={handleReportClick}>
			<ReportAbuseLink
				type={video.videoUrl ? 'video_comment' : 'comment'}
				comment={{ id: video.id, likes: Number(video.likeCount), role: 'VIDEO_COMMENT' }}
				petitionId={petitionId}
				petitionSlug={petitionSlug}
			>
				<Button
					icon={iconOutlinedFlag}
					size="small"
					mode="icon"
					aria-label={translate('corgi.components.petition_video.actions.aria_label.report_video', {
						user_name: video.user?.shortDisplayName ?? '',
					})}
					data-testid={`supporter-video-${video.id}-report-button`}
					sx={{
						// These styles override the design-system-legacy theme because they were designed when the
						// videos feature and design systems were being redesigned. When we move fully to sunrise these
						// can be reevaluated and replaced with ds-next standard buttons.
						// eslint-disable-next-line @typescript-eslint/naming-convention
						'& > *': { color: 'primary-black' },
						border: 'none',
						background: 'primary-greyBackground',
						// eslint-disable-next-line @typescript-eslint/naming-convention
						'&:hover': {
							background: 'rgba(0,0,0,0.1)',
						},
					}}
				>
					Report
				</Button>
			</ReportAbuseLink>
		</Flex>
	);
}
